import React from 'react';
import { LabelPanelGroup, LabelPanelGroupProps } from '../../layout/labelpanelgroup';

/**
 * {@docCategory FormPanelGroup}
 */
export interface FormPanelGroupProps extends Omit<LabelPanelGroupProps, 'useLargeVerticalGapSize'> {

}

export const FormPanelGroup = (props: React.PropsWithChildren<FormPanelGroupProps>) => {

   return (
      <LabelPanelGroup
         {...props}
         className={`uf-form-panel-group ${props.className || ''}`}
         useLargeVerticalGapSize={true}
      >
         {props.children}
      </LabelPanelGroup>
   );
};
